import { render, staticRenderFns } from "./CounselorCampaign.vue?vue&type=template&id=01da62f8&scoped=true"
import script from "./CounselorCampaign.vue?vue&type=script&lang=js"
export * from "./CounselorCampaign.vue?vue&type=script&lang=js"
import style0 from "./CounselorCampaign.vue?vue&type=style&index=0&id=01da62f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01da62f8",
  null
  
)

export default component.exports